<template>
  <KDiagramCalculationSuccessViewLarge
    ref="kDiagramCalculationSuccessViewLarge"
  />
</template>

<script>
import KDiagramCalculationSuccessViewLarge from "./calculation/views/Large.vue";
export default {
  name: "KDiagramSuccessView",
  components: {
    KDiagramCalculationSuccessViewLarge,

  },
};
</script>

<!--
Obsolete
<template>
  <KDiagramCalculationSuccessViewLarge
    ref="kDiagramCalculationSuccessViewLarge"
    v-if="isLargeScreen"
  />
  <KDiagramCalculationSuccessViewSmall
    ref="kDiagramCalculationSuccessViewSmall"
    v-else
  />
</template>

<script>
import KDiagramCalculationSuccessViewLarge from "./calculation/views/Large.vue";
import KDiagramCalculationSuccessViewSmall from "./calculation/views/Small.vue";
export default {
  name: "KDiagramSuccessView",
  components: {
    KDiagramCalculationSuccessViewLarge,
    KDiagramCalculationSuccessViewSmall,
  },
  computed: {
    isLargeScreen() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
};
</script>
-->
